import React, { useState, useEffect } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Modal, ModalHeader, ModalBody, Button, Form, Input, Row, Col, Label } from "reactstrap";
import { toast } from "react-toastify";
import { createProjectApi, updateProjectApi,getAmenitiesApi} from "../../apiServices/projectServices";
import useBuilders from "../../Hooks/useBuilders";

const ProjectModal = ({ isOpen, toggle, mode = "create", selectedProject, onSuccess }) => {
  const [formData, setFormData] = useState({
    projectName: "",
    builderName: "",
    projectType: "",
    projectStatus: "Upcoming",
    reraNumber: "",
  });
  console.log("selectedProject",selectedProject)
  const projectTypeOptions={
    Residential:[
      "Apartments",
      "Floors",
      "Farm House",
      "Villas",
      "Studio Apartments",
    ],
    Commercial:[
      "Office Spaces",
      "SCO Plots",
      "Retail Shops",
    ],
    Plots:[
      "Land Parcel Plots",
      "Villa Plots",
      "Agricultural Plots"
    ],
  };
  const { builders } = useBuilders({
    status:"active",
    withoutPagination:true,
  });
  const isViewMode = mode === "view";
  const [amenities, setAmenities] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchAmenities = async () => {
      const res = await getAmenitiesApi({ status: "active" });

      if (res.success) {
        const options = res.data.map((a) => ({
          value: a._id,
          label: a.name,
        }));

        setAmenities(options);
      }
    };

    fetchAmenities();
  }, []);

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && selectedProject) {
      setSelectedAmenities(
        selectedProject.amenities?.map((a) => ({
          value: a._id,
          label: a.name,
        })) || []
      );

      setFormData({
        projectName: selectedProject.projectName || "",
        builderName: selectedProject.builderName?._id || "",
        projectType: selectedProject.projectType || "",
        projectStatus: selectedProject.projectStatus || "Upcoming",
        reraNumber: selectedProject.reraNumber || "",
        projectHints: selectedProject.projectHints?.map((hint) => ({
                      value: hint,
                      label: hint,
                    })) || [],
      });
    }
  }, [mode, selectedProject]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.projectName || !formData.builderName || !formData.projectType ) {
      return toast.error("All required fields are mandatory");
    }

    try {
      setLoading(true);
      const payload = {
        ...formData,
        projectHints: formData.projectHints.map(item=>item.value),
        amenities: selectedAmenities.map((a) => a.value),
      };
      if (mode === "edit") {
        const res = await updateProjectApi(selectedProject._id, payload);

        if (!res.success) return toast.error(res.message);

        toast.success("Project updated");
      } else {
        const res = await createProjectApi(payload);

        if (!res.success) return toast.error(res.message);

        toast.success("Project created");
      }

      onSuccess && onSuccess();
      toggle();
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!isOpen) {
      setFormData({
        projectName: "",
        builderName: "",
        projectType: "",
        projectStatus: "Upcoming",
        reraNumber: "",
      });
      setSelectedAmenities([]);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {mode === "edit" ? "Edit Project" : mode === "view" ? "View Project" : "Create Project"}
      </ModalHeader>

      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Label for="projectName">Project Name *</Label>
              <Input
                name="projectName"
                disabled={isViewMode}
                placeholder="Project Name *"
                value={formData.projectName}
                onChange={handleChange}
              />
            </Col>

            <Col md={6}>
              <Label for="builderName">Builder *</Label>
              <Select
                isDisabled={isViewMode}
                options={builders.map((b) => ({
                  value: b._id,
                  label: b.name,
                }))}
                value={
                  builders
                    .map((b) => ({
                      value: b._id,
                      label: b.name,
                    }))
                    .find((b) => b.value === formData.builderName) || null
                }
                onChange={(selected) =>
                  setFormData((prev) => ({
                    ...prev,
                    builderName: selected?.value || "",
                  }))
                }
                placeholder="Select Builder *"
                classNamePrefix="react-select"
                isSearchable
              />
            </Col>
            <Col md={12} className="mt-3">
              <Label>Project Hints</Label>

              <CreatableSelect
                  isMulti
                  isDisabled={isViewMode}
                  value={formData.projectHints}
                  onChange={(selected)=>{

                      setFormData(prev=>({

                          ...prev,

                          projectHints:selected || []

                      }));

                  }}
              />
          </Col>
            <Col md={6} className="mt-3">
              <Label for="projectCategory">Project Category *</Label>

              <Input
                type="select"
                disabled={isViewMode}
                onChange={(e)=>{
                  setFormData((prev)=>({
                    ...prev,
                    projectCategory:e.target.value,
                    projectType:"",
                  }));
                }}
              >
                <option value="">Select Category</option>
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
                <option value="Plots">Plots</option>
              </Input>
            </Col>

            <Col md={6} className="mt-3">
              <Label for="projectType">Project Type *</Label>

              <Input
                type="select"
                disabled={isViewMode || !formData.projectCategory}
                name="projectType"
                value={formData.projectType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>

                {projectTypeOptions[formData.projectCategory]?.map((type)=>(
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={6} className="mt-3">
            <Label for="location">Location *</Label>
              <Input
                type="select"
                disabled={isViewMode}
                name="location"
                value={formData.location}
                onChange={handleChange}
              >
                <option value="">Select Location</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Gurgaon">Gurgaon</option>
                <option value="Goa">Goa</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Manesar">Manesar</option>
                <option value="Noida">Noida</option>
                <option value="Pune">Pune</option>
                <option value="Sohna">Sohna</option>
              </Input>
            </Col>

            <Col md={6} className="mt-3">
              <Label for="reraNumber">Rera Number </Label>
              <Input
                name="reraNumber"
                disabled={isViewMode}
                placeholder="RERA Number"
                value={formData.reraNumber}
                onChange={handleChange}
              />
            </Col>

            <Col md={6} className="mt-3">
              <Label for="projectStatus">Launch Status *</Label>
              <Input
                type="select"
                disabled={isViewMode}
                name="projectStatus"
                value={formData.projectStatus}
                onChange={handleChange}
              >
                <option value="Upcoming">Upcoming</option>
                <option value="Under Construction">Under Construction</option>
                <option value="Ready to Move">Ready to Move</option>
                <option value="Delivered">Delivered</option>
              </Input>
            </Col>
            <Col md={6} className="mt-3">
                <Select
                  isMulti
                  isDisabled={isViewMode}
                  options={amenities}
                  value={selectedAmenities}
                  onChange={(selected) => setSelectedAmenities(selected || [])}
                  placeholder="Select Amenities"
                  classNamePrefix="react-select"
                />
              </Col>
          </Row>

          {!isViewMode && (
              <div className="text-end mt-4">
                <Button color="primary" disabled={loading}>
                  {loading
                    ? mode === "edit"
                      ? "Updating..."
                      : "Creating..."
                    : mode === "edit"
                    ? "Update Project"
                    : "Create Project"}
                </Button>
              </div>
            )}
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ProjectModal;